module.exports = __webpack_public_path__ + "img/move.189181d2.svg";